import { Fieldset, ToggleGroup } from '@audio-network/componentlibrary'
import { useCurrentRefinements, useMenu } from 'react-instantsearch'

import React from 'react'
import SelectFilter from '../SelectFilter/SelectFilter'
import keyFacets from './KeyFacets'
import metreFacets from './MetreFacets'
import styles from './KeyFilter.module.css'
import { useTranslation } from 'next-i18next'

const KeyFilter = (
	props: JSX.IntrinsicAttributes &
		React.ClassAttributes<HTMLDivElement> &
		React.HTMLAttributes<HTMLDivElement>
): JSX.Element => {
	const { t } = useTranslation(['search'])
	const { items, refine } = useMenu({
		attribute: 'IsMajorKeyMood',
		sortBy: ['name:desc'],
	})

	const { items: keyItems, refine: KeyRefine } = useCurrentRefinements()

	const cancelKeyFilters = (attribute: string): void => {
		const refinedItem = keyItems?.find((item) => item.attribute === attribute)
			?.refinements[0]

		if (refinedItem) {
			KeyRefine(refinedItem)
		}
	}

	const handleMajorKeyMoodChange = (
		event: React.FormEvent<HTMLDivElement>
	): void => {
		const { value } = event.target as HTMLButtonElement

		cancelKeyFilters('KeyStart')
		cancelKeyFilters('KeyFinish')

		refine(value === t('key-mood-major') ? 'true' : 'false')
	}

	const clearMajorKeyMood = (): void => {
		const refinedItem = items?.find((item) => item.isRefined)
		if (refinedItem) {
			refine(refinedItem.value)
		}
	}

	const isPressed = (value: string): boolean => {
		return (
			keyItems?.find((item) => item.attribute === 'IsMajorKeyMood')
				?.refinements[0].value === value
		)
	}

	return (
		<div className={styles.keyMetre} {...props}>
			<Fieldset legend={t('key-mood')}>
				<ToggleGroup
					onChange={handleMajorKeyMoodChange}
					toggles={[
						{
							value: t('key-mood-major'),
							pressed: isPressed('true'),
							id: 'major-toggle',
						},
						{
							value: t('key-mood-minor'),
							pressed: isPressed('false'),
							id: 'minor-toggle',
						},
					]}
				/>
			</Fieldset>
			<div className={styles.openingClosingKey}>
				<SelectFilter
					attribute="KeyStart"
					curatedFacets={keyFacets}
					label={t('key-opening')}
					onSelect={clearMajorKeyMood}
				/>
				<SelectFilter
					attribute="KeyFinish"
					curatedFacets={keyFacets}
					label={t('key-closing')}
					onSelect={clearMajorKeyMood}
				/>
			</div>

			<div className={styles.divider} />
			<div className={styles.metre}>
				<SelectFilter
					attribute="Metre"
					curatedFacets={metreFacets}
					label={t('metre')}
				/>
			</div>
		</div>
	)
}

export default KeyFilter
